import { FC } from 'react'
import FailureBanner from '../FailureBanner'
import PendingBanner from '../PendingBanner'
import SuccessBanner from '../SuccessBanner'
import useBannerController from '../../hooks/useBannerController'

const BannerController: FC = () => {
  const { shouldShowSuccessBanner, shouldShowFailureBanner, shouldShowPendingBanner } =
    useBannerController()

  if (shouldShowSuccessBanner) return <SuccessBanner />
  if (shouldShowFailureBanner) return <FailureBanner />
  if (shouldShowPendingBanner) return <PendingBanner />

  return null
}

export default BannerController
